import { OWebApp, Utils } from "oweb";
import { SXAnswer, SXSurvey } from "@/gobl.bundle";
import ServiceStore from "./default";
import app from '@/app';
import Vue from 'vue';

type tSurveyAnswers = {
	[ question: string ]: {
		isValid: boolean,
		isEmpty: boolean,
		othersValue: string,
		value: string
	}
};
type tAnswersLog = {
	time: number,
	by?: string,
	answers: tSurveyAnswers
};
const LS = window.localStorage,
	LS_KEY = "_sx_unsent_answers";

export default class AnswersStore extends ServiceStore<SXAnswer> {
	private _unsent_answers: {
		[ key: string ]: tAnswersLog
	} = {};
	private _is_sending_answers: boolean = false;


	constructor(app: OWebApp) {
		super(app, SXAnswer, "answers");
		this.scheduleLoad(1000);
	}

	scheduleLoad(time: number = 5000) {
		let m = this;
		let timer = setInterval(function () {
			clearInterval(timer);
			m.loadAnswers();
			m.startUnsentAnswersSender();
		}, time);
	}

	addUserAnswer(phone: string, survey: SXSurvey, answers: tSurveyAnswers) {
		let key = `${ survey.id }_${ phone }`,
			log: tAnswersLog = {
				time: Date.now(),
				answers
			};

		if (app.userVerified()) {
			log.by = app.user.getCurrentUser().id
		}

		Vue.set(this._unsent_answers, key, log);

		this.saveAnswers();

		this.startUnsentAnswersSender();

		return this;
	}

	loadAnswers() {
		try {
			if (LS) {
				let dec: any,
					data = LS.getItem(LS_KEY);
				data = data ? JSON.parse(data) : {};
				dec = Utils.isPlainObject(data) ? data : {};
				this._unsent_answers = dec;
			}
		} catch (e) {
			console.error(e);
		}
	}
	saveAnswers() {
		try {
			if (LS) {
				let data = JSON.stringify(this._unsent_answers);
				LS.setItem(LS_KEY, data);
			}
		} catch (e) {
			console.error(e);
		}
	}
	getUnsentAnswers() {
		return this._unsent_answers;
	}

	getSurveyUnsentAnswers(survey: SXSurvey) {
		let result: Array<tAnswersLog & { phone: string }> = [];

		for (let key in this._unsent_answers) {
			let [ sid, phone ] = key.split("_");
			if (sid === survey.id) {
				result.push({
					...this._unsent_answers[ key ],
					phone
				});
			}
		}

		return result;
	}

	sendAnswer(survey_id: string, phone: string, answersLog: tAnswersLog, then: Function, error: Function) {

		let value = JSON.stringify(answersLog),
			data = {
				phone,
				[ SXAnswer.COL_SURVEY_ID ]: survey_id,
				[ SXAnswer.COL_VALUE ]: value
			};

		if (answersLog.by) {
			data[ SXAnswer.COL_BY_ID ] = answersLog.by;
		}

		this.add(data, function () {
			then();
		}, function () {
			error()
		}, false, false);
	}

	startUnsentAnswersSender() {
		if (!this._is_sending_answers) {
			console.log("[AnswersStore] trying to send unsent answer!");
			this._is_sending_answers = true;
			let x = this,
				retry_count = 0,
				max_retry_count = 6,
				delay = 400,
				retry_delay = 5000,
				current_key: any;

			let success = function () {
				Vue.delete(x._unsent_answers, current_key);
				x.saveAnswers();
				setTimeout(next, delay);
			};

			let fail = function () {
				if (retry_count < max_retry_count) {
					retry_count += 1;
					setTimeout(next, retry_delay);
				} else {
					x._is_sending_answers = false;
				}
			};

			let next = function () {
				current_key = Object.keys(x._unsent_answers).pop();
				if (current_key) {
					let log = x._unsent_answers[ current_key ],
						[ survey_id, phone ] = current_key.split("_");
					x.sendAnswer(survey_id, phone, log, success, fail);
				} else {
					x._is_sending_answers = false;
					setTimeout(() => {
						x.startUnsentAnswersSender();
					}, 3000);
				}
			};

			next();
		}
	}
}
